<template>
  <div>
    <Layout>
      <AuPairFilters
        v-on:applyFilters="applyFilters"
        v-on:clearFilter="clearFilter"
      />

      <div v-if="aupairs && aupairs.length > 0">
        <FilterSummary
          :totalEntries="totalOfEntries"
          :filters="this.$store.state.filters"
          :showTotal="true"
          v-on:clear-filters="clearFilter()"
        />

        <ul>
          <li v-for="(aupair, index) in aupairs" :key="index">
            <AuPairCard :aupair="aupair" />
          </li>
        </ul>

        <div
          v-if="totalOfEntries > entriesPerPage"
          class="shadow-lg bg-white mb-4 rounded-b rounded-t overflow-hidden p-5"
        >
          <ListingPagination
            :totalOfEntries="totalOfEntries"
            :entriesPerPage="entriesPerPage"
          />
        </div>
      </div>
      <div v-else-if="aupairs && aupairs.length === 0">
        <div class="flex w-full justify-end">
          <FilterSummary
            :totalEntries="totalOfEntries"
            :filters="this.$store.state.filters"
            :showTotal="false"
            v-on:clear-filters="clearFilter()"
          />
        </div>

        <div
          class="shadow-lg bg-white mb-4 rounded-b rounded-t overflow-hidden p-5"
        >
          <h3 class="text-center">
            No results found matching your criteria.
          </h3>
        </div>
      </div>
      <ComponentLoading v-else />
    </Layout>
    <FinderCTA />
  </div>
</template>

<script>
import Layout from "@/Layout/Authenticated/Layout.vue";
import AuPairCard from "@/components/AuPairs/AuPairCard.vue";
import AuPairFilters from "@/components/AuPairs/AuPairFilters.vue";
import FilterSummary from "@/components/AuPairs/FiltersSummary.vue";
import ListingPagination from "@/components/AuPairs/ListingPagination.vue";
import FinderCTA from "@/components/Finder/FinderCTA.vue";
import { ChiStringifyFilter } from "@/helpers.js";
import { api } from "@/services.js";
import moment from "moment";

export default {
  name: "AvailableAuPairs",
  components: {
    Layout,
    AuPairCard,
    AuPairFilters,
    FilterSummary,
    ListingPagination,
    FinderCTA,
  },
  data() {
    return {
      aupairs: null,
      availableCountries: null,
      totalOfEntries: 0,
      entriesPerPage: 5,
      filters: this.applyFilters(),
      filtersDelayTimer: null,
    };
  },
  created() {
    this.applyFilters();
    this.pullData();
  },
  computed: {
    url() {
      return `/promotional/AuPairPromoProfiles?page=${
        this.$route.query.page
      }&pageSize=${this.entriesPerPage}${ChiStringifyFilter(
        this.filters
      )}&sort=score-desc~FirstAvailableDate-desc`;
    },
  },
  methods: {
    pullData() {
      if (this.filtersDelayTimer) {
        clearTimeout(this.filtersDelayTimer);
      }

      this.filtersDelayTimer = setTimeout(() => {
        this.aupairs = null;
        api.get(this.url).then((r) => {
          this.totalOfEntries = Number(r.data.total);
          this.aupairs = r.data.data;
        });
      }, 1000);
    },
    clearFilter() {
      this.aupairs = null;
      this.$store.dispatch("clearFilter");
      this.$router.push({ query: { page: "1" } }).catch(() => {});
    },

    applyFilters() {
      const stateFilters = this.$store.state.filters;

      let filters = [];

      this.filters = [];

      const ageFrom = moment()
        .subtract(stateFilters.ageFrom, "years")
        .format("lll");

      const ageTo = moment()
        .subtract(stateFilters.ageTo, "years")
        .format("lll");

      filters.push({
        field: "birthDate",
        operator: "lte",
        value: ageFrom,
      });

      if (stateFilters.name !== "") {
        filters.push({
          field: "firstName",
          operator: "contains",
          value: stateFilters.name,
        });
      }

      filters.push({
        field: "birthDate",
        operator: "gte",
        value: ageTo,
      });

      if (stateFilters.birthCountry !== "all") {
        filters.push({
          field: "birthCountry",
          operator: "eq",
          value: stateFilters.birthCountry,
        });
      }

      if (stateFilters.experiencedDriver !== "all") {
        filters.push({
          field: "drivingExperience",
          operator: "gte",
          value: stateFilters.experiencedDriver,
        });
      }

      if (stateFilters.infantCareQualified !== "all") {
        filters.push({
          field: "infantCareQualified",
          operator: "eq",
          value: stateFilters.infantCareQualified,
        });
      }

      if (stateFilters.swimmer !== "all") {
        filters.push({
          field: "swimmingSkills",
          operator: "gte",
          value: stateFilters.swimmer,
        });
      }

      if (stateFilters.gender !== "any") {
        filters.push({
          field: "gender",
          operator: "eq",
          value: stateFilters.gender,
        });
      }

      // if (stateFilters.inCountry !== "all") {
      //   filters.push({
      //     field: "inCountry",
      //     operator: "eq",
      //     value: stateFilters.inCountry,
      //   });
      // }

      this.filters = filters;
    },
  },
  watch: {
    url() {
      this.pullData();
    },
  },
};
</script>
